export const environment = {
  production: false,
  // apiUrl: 'https://fc19-62-8-84-42.ngrok-free.app/',
  apiUrl: 'https://api-merchant-sandbox.scripay.com/',
  apiUrl_2: 'https://bills-sandbox.scripay.com/',
  dashboardUrl: 'https://merchant-sandbox.scripay.com/',
  landingPageUrl: 'https://sandbox.scripay.com/',
  mediaUrl:'https://water-django-project.s3.ap-south-1.amazonaws.com/media/',
};
